// Mirrors Core/DataModel/Unit/Rd/ResearchAndDevelopmentInformation.cs
// Shared across the RD tier forms (LQRE / IncreaseInRD / SBIR) — PDF Section Two.
export class ResearchAndDevelopmentInformation {
  taxYear: number;
  businessDescription: string;
  companyLocations: string;
  federalQualifiedResearchExpenses: number;
  hasOutOfStateResearch: boolean;
  outOfStateResearchLocations: string;
  laQualifiedResearchExpenses: number;
  sbirSttrAwardsReceived: number;
  threePrevYearsAvgLaQre: number;
  totalEmployees: number;
  totalRdEmployees: number;
  avgWageNonRdEmployees: number;
  avgWageRdEmployees: number;
  avgBenefitsValue: number;
  employerHealthInsCost: number;

  constructor(researchAndDevelopmentInformation?: any) {
    if (researchAndDevelopmentInformation) {
      Object.assign(this, researchAndDevelopmentInformation);
    }
  }
}
